import {Link, useLocation} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import styles from './AppSidebar.module.scss';

function AppSidebar({
  isC5FlagOn,
  isEvolutionFlagOn,
  isStudentRecommendationsAndAlertsOn,
  shouldShowContestResult,
}: {
  isC5FlagOn: boolean;
  isEvolutionFlagOn: boolean;
  isStudentRecommendationsAndAlertsOn: boolean;
  shouldShowContestResult?: boolean;
}): JSX.Element {
  const {pathname} = useLocation();
  const {trackEvent} = useTrackEvent();

  const {userRole} = getUserData();

  const menuItems = [
    {
      label: 'Trilhas',
      icon: 'books',
      path: '/',
    },

    ...(shouldShowContestResult
      ? [
          {
            label: 'Olimpíada',
            icon: 'medal',
            path: '/resultado-olimpiadas',
          },
        ]
      : []),

    ...(!isC5FlagOn && isStudentRecommendationsAndAlertsOn
      ? [
          {
            label: 'Recomendações',
            icon: 'book-open-cover',
            path: '/recomendacoes',
          },
          {
            label: 'Mensagens',
            icon: 'message',
            path: '/mensagens',
          },
          ...(isEvolutionFlagOn
            ? [
                {
                  label: 'Evolução',
                  icon: 'chart-line-up',
                  path: '/evolucao',
                },
              ]
            : []),
        ]
      : []),

    ...(isC5FlagOn
      ? [
          {
            label: 'Práticas',
            icon: 'book-open-cover',
            path: '/praticas',
          },
        ]
      : []),
  ];

  function handleMenuClick(label: string) {
    if (label === 'Mensagens') {
      trackEvent('accessed_messages_page_student', {
        user: {
          userrole_id: userRole?.id,
        },
        school: {
          school_id: userRole?.school,
          schoolgroup_id: userRole?.school_group,
        },
      });
    }

    if (label === 'Recomendações') {
      trackEvent('accessed_recommendations_page_student', {
        user: {
          userrole_id: userRole?.id,
        },
        school: {
          school_id: userRole?.school,
          schoolgroup_id: userRole?.school_group,
        },
      });
    }

    if (label === 'Olimpíada') {
      trackEvent('accessed_contest_result_page_sidebar_student');
    }
  }

  return (
    <menu className={styles.container}>
      {menuItems.map((item) => (
        <li key={item.label} className={styles.menuItem}>
          <Link
            to={item.path}
            className={`${styles.link} ${
              pathname === item.path ? styles.active : ''
            }`}
            onClick={() => handleMenuClick(item.label)}
          >
            <FontAwesomeIcon icon={['fad', item.icon as IconName]} size="2xl" />
            <span>{item.label}</span>
          </Link>
        </li>
      ))}
    </menu>
  );
}

export default AppSidebar;
